/** Deep-merge plain JSON objects; arrays and primitives from `overlay` win. */
export function deepMerge(base, overlay) {
    const result = { ...base };
    for (const [key, value] of Object.entries(overlay)) {
        const current = result[key];
        if (value &&
            typeof value === 'object' &&
            !Array.isArray(value) &&
            current &&
            typeof current === 'object' &&
            !Array.isArray(current)) {
            result[key] = deepMerge(current, value);
        }
        else {
            result[key] = value;
        }
    }
    return result;
}
//# sourceMappingURL=deep-merge.js.map